import {
  GET_BUTTON_REPAIR_MOVEMENT,
  GET_REPAIR_SEAL_MOVEMENT,
  GET_FINAL_SEAL_MOVEMENT
} from 'shared/constants/ActionTypes';

export function addNewNoSealDispatch(data) {
  return (dispatch) => {
    dispatch({type: 'ADD_NEW_NO_SEAL', payload: data});
  };
}

export function resetNewNoSealDispatch() {
  return (dispatch) => {
    dispatch({type: 'RESET_NEW_NO_SEAL', payload: []});
  };
}

export function selectRepairNoSeal(data) {
  return (dispatch) => {
    dispatch({type: 'SELECT_REPAIR_NO_SEAL', payload: data});
  };
}

const setButton = (payload) => {
  return {
    type: GET_BUTTON_REPAIR_MOVEMENT,
    payload,
  };
};

const setSeal = (payload) => {
  return {
    type: GET_REPAIR_SEAL_MOVEMENT,
    payload,
  };
};

const setFinal = (payload) => {
  return {
    type: GET_FINAL_SEAL_MOVEMENT,
    payload,
  };
};

export const setButtonRepair = (payload) => {
  return (dispatch) => {
    dispatch(setButton(payload));
  };
};

export const setSealNoList = (payload) => {
  return (dispatch) => {
    dispatch(setSeal(payload));
  };
};

export const setFinalSeal = (payload) => {
  return (dispatch) => {
    dispatch(setFinal(payload));
  };
};
